import { render } from "./dropZoneCsv.vue?vue&type=template&id=34bb1344&scoped=true"
import script from "./dropZoneCsv.vue?vue&type=script&lang=js"
export * from "./dropZoneCsv.vue?vue&type=script&lang=js"

import "./dropZoneCsv.vue?vue&type=style&index=0&id=34bb1344&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34bb1344"]])

export default __exports__